import CouponsLotusList from './CouponsLotusList'

export default CouponsLotusList
